/**
 * Says an hour count the way a person would.
 *
 * Scan ages are stored in hours because that is the unit the rescan window is
 * configured in, and 402 is not a number anyone can judge at a glance.
 */
export function humanHours(value: number): string {
  if (!Number.isFinite(value)) {
    return '—';
  }

  if (value < 48) {
    return `${trim(value)} h`;
  }

  const days = value / 24;

  return days >= 14 && days % 7 === 0 ? `${trim(days / 7)} weeks` : `${trim(days)} days`;
}

/** 20 rather than 20.0, but 1.5 kept. */
function trim(value: number): string {
  return Number(value.toFixed(1)).toString();
}
